/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/require-default-props */
import React, { useMemo } from "react";
// import { blogToBlogSchema, localBusinessSchema, OrganizationSchema } from "./schemaOrg/schema";
// import { IBlogDetail } from "@modules/types/blogs";
import { Helmet } from "react-helmet";
import { clarityData, convertOgMeta, convertTwitterMeta, scriptSchema } from "../../utils/metaDetail";

type MetaTagsProps = {
  metaDescription?: string;
  metaTitle?: string;
  url?: string;
  title?: string;
  keyword?: Array<string>;
  metaTags?: {
    title?: string;
    description?: string;
    keyword?: string;
    originalSource?: string;
    og?: {
      title?: string;
      description?: string;
      image?: string;
      type?: string;
      url?: string;
      imageWidth?: string;
      imageHeight?: string;
      siteName?: string;
    };
    article?: {
      publisher?: string;
      publishedTime?: string;
      modifiedTime?: string;
      author?: string;
      tag?: string;
    };
    twitter?: {
      card?: string;
      site?: string;
      image?: string;
      imageWidth?: string;
      imageHeight?: string;
      description?: string;
      url?: string;
      title?: string;
    };
  };
  faqSchema?: any;
};

function MetaTags({ metaTitle, metaDescription, title, metaTags, keyword, url, faqSchema }: MetaTagsProps) {
  const mainTitle = `${title} | ${clarityData.name}`;

  const twitterTags = useMemo(
    () => ({
      image: clarityData.logo,
      title: metaTitle,
      description: metaDescription,
      ...(metaTags?.twitter ?? {}),
    }),
    [metaTags?.twitter, metaTitle, metaDescription],
  );

  const ogTags = useMemo(
    () => ({
      image: clarityData.logo,
      title: metaTitle,
      description: metaDescription,
      ...(metaTags?.og ?? {}),
    }),
    [metaTags?.og, metaTitle, metaDescription],
  );

  //   const jsonBlogData = blogToBlogSchema(blogSchemaOrg);

  return (
    <Helmet>
      {title && <title>{mainTitle}</title>}
      {keyword && <meta name="keyword" content={keyword?.join(",")} />}
      {metaTitle && <meta name="title" content={metaTitle} />}
      {metaDescription && <meta name="description" content={metaDescription} />}
      {url && <meta name="original-source" content={`${clarityData.site}${url}`} />}

      {/* {scriptSchema(OrganizationSchema, Schema.organization)}
      {scriptSchema(localBusinessSchema, Schema.localBusiness)} */}
      {/* {blogSchemaOrg && scriptSchema(jsonBlogData, Schema.newsArticle)} */}
      {faqSchema && scriptSchema(faqSchema, "Faq")}
      {/* {setAllMetas(twitterTags, ogTags)} */}
      {convertTwitterMeta(twitterTags)}
      {convertOgMeta(ogTags)}
    </Helmet>
  );
}

export default MetaTags;
